import { Form, Formik } from "formik";
import { FC } from "react";
import { config } from "../config";
import { Product, Useplace } from "../types";
import { yupOrderFormSchema } from "../yupOrderFormSchema";

export type OrderFormValues = {
  useplace: string;
  site: string;
  firstname: string;
  lastname: string;
  email: string;
  mobile: string;
  personalnumber: string;
  address_street: string;
  address_streetno: string;
  address_letter: string;
  address_co: string;
  address_apartment: string;
  address_zip: string;
  address_city: string;
  invoice_street: string;
  invoice_streetno: string;
  invoice_letter: string;
  invoice_co: string;
  invoice_apartment: string;
  invoice_zip: string;
  invoice_city: string;
  message: string;
  // startdatum
  startdate: string;
  // godkännanden
  approval_owner: boolean;
  approval_com_email: boolean;
  approval_com_sms: boolean;
  approval_integrity: boolean;
  approval_details: false;
  approval_summary: false;
  // selectedProducts
  selectedProducts: Product[];
};

interface Props {
  children: React.ReactNode;
  address: Useplace;
  products: Product[];
}

export const OrderFormWrapper: FC<Props> = ({
  children,
  address,
  products,
}) => {
  // console.log("💔 address", address);
  // console.log("💔 products", products);
  return (
    <Formik
      initialValues={{
        useplace: "",
        site: "",
        firstname: undefined,
        lastname: "",
        email: "",
        mobile: "",
        personalnumber: "",
        address_street: "",
        address_streetno: "",
        address_letter: "",
        address_co: "",
        address_apartment: "",
        address_zip: "",
        address_city: "",
        invoice_street: "",
        invoice_streetno: "",
        invoice_letter: "",
        invoice_co: "",
        invoice_apartment: "",
        invoice_zip: "",
        invoice_city: "",
        message: "",
        // startdatum
        startdate: "",
        // godkännanden
        approval_owner: false,
        approval_com_email: false,
        approval_com_sms: false,
        approval_integrity: false,
        approval_details: false,
        approval_summary: false,
        selectedProducts: [],
      }}
      validationSchema={yupOrderFormSchema}
      validateOnChange={false}
      isInitialValid={false}
      // validateOnBlur={false}
      validateOnMount={false}
      onSubmit={async (values) => {
        // console.log("🚀🚀🚀🚀: ", values);
        // console.log("🚀🚀🚀🚀: ", address);
        // console.log("🚀🚀🚀🚀: ", products);
        try {
          const dataTosend = {
            ...values,
            personalnumber: values.personalnumber.includes("-")
              ? values.personalnumber
              : `${values.personalnumber.substring(
                  0,
                  8
                )}-${values.personalnumber.substring(
                  8,
                  values.personalnumber.length
                )}`,
          };
          console.log("🚀👍😂", dataTosend);
          const res = await fetch(`${config.API_URL}/order/createorder`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },

            body: JSON.stringify({ ...dataTosend }),
          });
          const data = (await res.json()) as { destination: string };
          // console.log("🚀🚀🚀🚀🐩: ", data);

          // var recipient = data.recipients.filter(
          //   (r) => r.first_name !== "Lunet"
          // );

          // console.log("🚀🚀🚀🚀👍: ", recipient);
          // if (recipient.length > 0) {
          window.location.href = data.destination;
          // }
          // if (data.status === "ok") {
          //   const orderData = data.data as OrderResponse;

          // document.location.href = "/order/tack";
          // redirect("/order/tack");
          // } else {
          //   alert("Något gick fel, vänligen försök igen senare");
          // }
        } catch (error) {
          console.error(error);
        }
      }}
    >
      <Form>{children}</Form>
    </Formik>
  );
};
